module.exports = __webpack_public_path__ + "img/evaluateItemLogo3.fe55992f.png";